// src/components/Icon/Icon.tsx

export const IconMap = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13" />
            <path d="M9 12v.01" />
            <path d="M6 13v.01" />
            <path d="M17 15l-4 -4" />
            <path d="M13 15l4 -4" />
        </svg>
    );
};

export const IconCalendar = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
            <path d="M16 3l0 4" />
            <path d="M8 3l0 4" />
            <path d="M4 11l16 0" />
            <path d="M8 15h2v2h-2z" />
        </svg>
    );
};

export const IconTime = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 12l3 2" />
            <path d="M12 7v5" />
        </svg>
    );
};

export const IconCurrentLocation = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 1a1 1 0 0 1 1 1v1.055a9.004 9.004 0 0 1 7.946 7.945h1.054a1 1 0 0 1 0 2h-1.055a9.004 9.004 0 0 1 -7.944 7.945l-.001 1.055a1 1 0 0 1 -2 0v-1.055a9.004 9.004 0 0 1 -7.945 -7.944l-1.055 -.001a1 1 0 0 1 0 -2h1.055a9.004 9.004 0 0 1 7.945 -7.945v-1.055a1 1 0 0 1 1 -1m0 4a7 7 0 1 0 0 14a7 7 0 0 0 0 -14m0 3a4 4 0 1 1 -4 4l.005 -.2a4 4 0 0 1 3.995 -3.8" />
        </svg>
    );
};

export const IconReset = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3.06 13a9 9 0 1 0 .49 -4.087" />
            <path d="M3 4.001v5h5" />
            <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        </svg>
    );
};

export const IconBuilding = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 21v-15c0 -1 1 -2 2 -2h5c1 0 2 1 2 2v15" />
            <path d="M16 8h2c1 0 2 1 2 2v11" />
            <path d="M3 21h18" />
            <path d="M10 12v0" />
            <path d="M10 16v0" />
            <path d="M10 8v0" />
            <path d="M7 12v0" />
            <path d="M7 16v0" />
            <path d="M7 8v0" />
            <path d="M17 12v0" />
            <path d="M17 16v0" />
        </svg>
    );
};

export const IconRepeat = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
            <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
        </svg>
    );
};

export const IconRepeatOnce = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
            <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
            <path d="M11 11l1 -1v4" />
        </svg>
    );
};

export const IconDesc = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
            <path d="M9 17h6" />
            <path d="M9 13h6" />
        </svg>
    );
};

export const IconUsers = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
            <path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
            <path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
            <path d="M17 10h2a2 2 0 0 1 2 2v1" />
            <path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
            <path d="M3 13v-1a2 2 0 0 1 2 -2h2" />
        </svg>
    );
};

export const IconLink = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M9 15l6 -6" />
            <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
            <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
        </svg>
    );
};

export const IconSearch = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
            <path d="M21 21l-6 -6" />
        </svg>
    );
};

export const IconPlus = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
            <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
            <path d="M11 10h6" />
            <path d="M14 7v6" />
        </svg>
    );
};

export const IconMail = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5" />
            <path d="M11.5 19h-6.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5" />
            <path d="M3 7l9 6l9 -6" />
        </svg>
    );
};

export const IconLocation = ({
    size = 24, // Domyślny rozmiar ikony
    color = "currentColor", // Domyślny kolor (podąża za kolorem tekstu)
    className = "", // Opcjonalna klasa do stylowania
    ...props
}) => {
    return (
        <svg
            // Otwieramy możliwość nadpisania pozostałych props (np. onClick)
            {...props}
            // Łączymy klasę 'icon' z klasami przekazanymi przez prop className
            className={`icon ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.901 8.034" />
            <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z" />
            <path d="M19 18v.01" />
        </svg>
    );
};
